import dayjs from 'dayjs'

export const fullDate = (timestamp) => timestamp ? dayjs(timestamp).format('YYYY-MM-DD') : '-'

export const fullTime = (timestamp) => timestamp ? dayjs(timestamp).format('HH:mm') : '-'